import { ActivatedRoute, Route, Router, RouterModule } from "@angular/router";
import {
  getRandomQuestions,
  getStudyMethod,
  setStudyMethod,
} from "src/app/store/selectors/game.selectors";
import {
  getChapterById,
  getChaptersByIds,
  getLessonTypes,
} from "./../store/selectors/game.selectors";
import { Observable } from "rxjs";
import {
  Book,
  Chapter,
  LessonCheckbox,
  Question,
  Type,
} from "src/app/models/game";
import {
  getGameData,
  playEnglishToJapanese,
  playJapaneseToEnglish,
  setChapterDetails,
  setGameQuestions,
} from "./../store/actions/game.actions";
import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { GameState } from "../store/reducers/game.reducer";
import { getBook } from "../store/selectors/game.selectors";
import { take } from "rxjs/operators";

@Component({
  selector: "app-games",
  templateUrl: "./games.component.html",
  styleUrls: ["./games.component.scss"],
})
export class GamesComponent implements OnInit {
  book$: Observable<Book>;
  chapter$: Observable<Chapter>;
  question$: Observable<Question>;
  questions$: Observable<Question[]>;
  lessonsLoaded$: Observable<Chapter[]>;
  lessonTypes$: Observable<any>;
  studyMethod$: Observable<string>;
  types: Array<Type> = [];
  kanaPractice = false;
  genkiBook1 = false;
  genkiBook2 = false;
  lessons: Array<LessonCheckbox> = [];
  routeTo: string;
  nouns = false;
  verbs = false;
  adjectives = false;
  adverbs = false;
  japaneseToEnglish = true;
  englishToJapanese = false;

  constructor(
    private store: Store<GameState>,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.book$ = this.store.select(getBook);
    this.studyMethod$ = this.store.select(getStudyMethod);
  }

  ngOnInit() {
    this.store.dispatch(getGameData());
    for (let i = 1; i < 26; i++) {
      this.lessons.push({
        id: i,
        name: "lesson" + i,
        isChecked: false,
      });
    }
  }

  removeFromLessons(currentLesson) {
    this.lessons[currentLesson].isChecked = false;
  }

  changeGameStatus(game) {
    if (game === "japaneseToEnglish") {
      setTimeout(() => {
        this.englishToJapanese = false;
      });
    } else {
      setTimeout(() => {
        this.japaneseToEnglish = false;
      });
    }
  }

  removeBook(book) {
    if (book === 1) {
      this.kanaPractice = false;
    } else if (book === 2) {
      for (let i = 0; i < 13; i++) {
        this.removeFromLessons(i);
      }
      this.genkiBook1 = false;
    } else {
      for (let i = 13; i < 23; i++) {
        this.removeFromLessons(i);
      }
      this.genkiBook2 = false;
    }
  }

  loadLessons(id, index) {
    if (this.lessons[index]) {
      if (this.lessons[index].isChecked) {
        this.lessons.forEach((lesson) => {
          if (lesson.id !== id) {
            lesson.isChecked = false;
          }
        });
        const lessonToLoad = this.lessons.filter(
          (lesson) => lesson.isChecked === true
        )[0];
        this.lessonsLoaded$ = this.store.select(getChaptersByIds(lessonToLoad));
        this.lessonTypes$ = this.store.select(getLessonTypes(lessonToLoad));
        this.lessonTypes$.subscribe((lessonTypes) => {
          this.types = [];
          if (lessonTypes) {
            lessonTypes.forEach((type) => {
              this.types.push({ name: type, isChecked: true });
            });
          }
        });
      } else {
        this.types = [];
      }
    }
  }
  goToGame() {
    if (this.lessonsLoaded$) {
      this.lessonsLoaded$.pipe(take(1)).subscribe((lesson) => {
        const uncheckedTypes = this.types.filter((type) => !type.isChecked);
        const filters = [];
        uncheckedTypes.forEach((type) => filters.push(type.name));
        if (lesson) {
          this.chapter$ = this.store.select(
            getChapterById(lesson[0].id, filters)
          );

          this.chapter$
            .pipe(take(1))
            .subscribe((payload) =>
              this.store.dispatch(setChapterDetails({ payload }))
            );
          this.questions$ = this.store.select(
            getRandomQuestions(lesson[0].id, filters)
          );
          this.questions$
            .pipe(take(1))
            .subscribe((payload) =>
              this.store.dispatch(setGameQuestions({ payload }))
            );

          if (this.englishToJapanese) {
            this.studyMethod$
              .pipe(take(1))
              .subscribe((payload) =>
                this.store.dispatch(playEnglishToJapanese())
              );
          } else if (this.japaneseToEnglish) {
            this.studyMethod$
              .pipe(take(1))
              .subscribe((payload) =>
                this.store.dispatch(playJapaneseToEnglish())
              );
          }
        }
      });
    }
  }
}
